import api from './api';

const CONFIG_TABLE = 'MARKET_StripeConfig';
const PUBLIC_VIEW = 'vw_MARKET_StripeConfigPublic';

export const stripeService = {
  getPublicConfigs: () => api.get(PUBLIC_VIEW),

  getDefaultPublicKey: async () => {
    const configs = await api.get(PUBLIC_VIEW);
    const defaultConfig = configs.find(c => c.isDefault && c.isActive);
    if (defaultConfig) return defaultConfig;
    const anyActive = configs.find(c => c.isActive);
    return anyActive || null;
  },

  getAllConfigs: () => api.get(CONFIG_TABLE),

  getByStore: async (storeId) => {
    const configs = await api.get(CONFIG_TABLE);
    return configs.filter(c => c.StoreId === storeId);
  },
  getById: (id) => api.getById(CONFIG_TABLE, id),
  create: (data) => api.post(CONFIG_TABLE, data),
  update: (id, data) => api.patch(CONFIG_TABLE, id, data),
  delete: (id) => api.delete(CONFIG_TABLE, id),

  setDefault: async (id) => {
    const configs = await api.get(CONFIG_TABLE);
    const updates = configs
      .filter(c => c.isDefault)
      .map(c => api.patch(CONFIG_TABLE, c.apiid, { isDefault: false }));
    await Promise.all(updates);
    return api.patch(CONFIG_TABLE, id, { isDefault: true });
  },

  createPaymentIntent: (amount, name, email, stripeConfigId) =>
    api.postUrl(`${process.env.REACT_APP_API_BASE}/create-payment-intent`, {
      amount,
      name,
      email,
      paymentMethodType: 'card',
      stripeConfigId,
    }),
};

export default stripeService;
